import { PodcastsLayout } from 'features/podcasts/components/PodcastsLayout/PodcastsLayout.component';
import React from 'react';
import { defaultNamespaces } from '@utils/strings';
import { PlcNextPage, PlcNextPageContext } from 'features/business/app.types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const PodcastsHome: PlcNextPage = () => {
  return <PodcastsLayout />;
};

export async function getServerSideProps(ctx: PlcNextPageContext) {
  const pageDefaultState = [...defaultNamespaces, 'podcasts', 'common'];
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale || 'fr', pageDefaultState)),
    },
  };
}

export default PodcastsHome;
